export default "<div class=\"wrapper\">\n    <ng-content></ng-content>\n  <p *ngIf=\"isLoading !== true && !isHasChild\">\n  No data\n  </p>\n</div>\n";